import Vue from 'vue';

export default {
    namespaced: true,
    state: {
        sessionId: undefined,
    },
    mutations: {
        setSessionId(state, value) {
            Vue.set(state, 'sessionId', value);
        }
    },
    actions: {
        setSessionId({ commit }, value) {
            commit('setSessionId', value);
        },
    },
    getters: {
        getSessionId: (state) => state.sessionId,
    },
}
